import React from 'react';
import PropTypes from 'prop-types';

const MiniMize = ({ className }) => {
    return (

        // <svg
        //     width="44"
        //     height="44"
        //     viewBox="0 0 44 44"
        //     xmlns="http://www.w3.org/2000/svg"
        //     className={`fill-current ${className}`}
        //     fill="currentColor" // Ensures the color can be changed dynamically
        //     >
        //     <rect width="44" height="44" rx="22" fill="#B2B2B2" fill-opacity="0.64" />
        //     <path d="M18 13V16C18 16.5304 17.7893 17.0391 17.4142 17.4142C17.0391 17.7893 16.5304 18 16 18H13M31 18H28C27.4696 18 26.9609 17.7893 26.5858 17.4142C26.2107 17.0391 26 16.5304 26 16V13M26 31V28C26 27.4696 26.2107 26.9609 26.5858 26.5858C26.9609 26.2107 27.4696 26 28 26H31M13 26H16C16.5304 26 17.0391 26.2107 17.4142 26.5858C17.7893 26.9609 18 27.4696 18 28V31" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        // </svg>

        <svg width="28" 
        className={className}
        height="28" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg">
            <path d="M8 3V6C8 6.53043 7.78929 7.03914 7.41421 7.41421C7.03914 7.78929 6.53043 8 6 8H3M21 8H18C17.4696 8 16.9609 7.78929 16.5858 7.41421C16.2107 7.03914 16 6.53043 16 6V3M16 21V18C16 17.4696 16.2107 16.9609 16.5858 16.5858C16.9609 16.2107 17.4696 16 18 16H21M3 16H6C6.53043 16 7.03914 16.2107 7.41421 16.5858C7.78929 16.9609 8 17.4696 8 18V21" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>


    );
};

MiniMize.propTypes = {
    className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

MiniMize.defaultProps = {
    className: '', // Default to an empty string
};

export default MiniMize;